// extracted by mini-css-extract-plugin
export default {"iframeWrapper":"iframeWrapper--UVd6x"};